import Legal from "../Legal";

export default function Mentions() {
  return (
    <Legal title="Mentions Légales" subtitle="Dernière mise à jour : 18 mai 2026">
      <h2>1. Éditeur du site</h2>
      <p>
        Le site <strong>nordstellatech.fr</strong> est édité par :
      </p>
      <ul>
        <li><strong>Entrepreneur</strong> : Lacina DIOMANDE</li>
        <li><strong>Statut juridique</strong> : Auto-entrepreneur (Micro-entreprise)</li>
        <li><strong>SIRET</strong> : 104 860 663 00012</li>
        <li><strong>Adresse</strong> : 1 CHE d'Acces aux Abbesses, 93220 Gagny, FRANCE</li>
        <li><strong>Email</strong> : nordstellatech@gmail.com</li>
        <li><strong>Directeur de la publication</strong> : Lacina DIOMANDE</li>
      </ul>

      <h2>2. Hébergement</h2>
      <p>
        Le site est hébergé par <strong>Emergent</strong> via une infrastructure
        cloud sécurisée. Les données utilisateurs sont stockées dans un
        environnement conforme au RGPD.
      </p>

      <h2>3. Propriété intellectuelle</h2>
      <p>
        L'ensemble des contenus présents sur le site (textes, images, logos,
        marques, structure, code) est la propriété exclusive de Nord Stella Tech
        ou de ses partenaires. Toute reproduction, représentation,
        modification, publication, transmission, dénaturation, totale ou
        partielle, est strictement interdite sans autorisation écrite préalable.
      </p>

      <h2>4. Données personnelles</h2>
      <p>
        Le traitement de vos données personnelles est régi par notre
        <a href="/legal/privacy"> Politique de Confidentialité</a>, conforme au
        Règlement Général sur la Protection des Données (RGPD).
      </p>

      <h2>5. Cookies</h2>
      <p>
        Le site utilise des cookies strictement nécessaires au fonctionnement
        (authentification, panier). Aucun cookie publicitaire ou de tracking
        tiers n'est déployé sans votre consentement explicite.
      </p>

      <h2>6. Loi applicable</h2>
      <p>
        Les présentes mentions légales sont soumises au droit français. Tout
        litige relatif à leur interprétation ou exécution relève de la
        compétence exclusive des tribunaux français.
      </p>

      <h2>7. Contact</h2>
      <p>
        Pour toute question relative au site, vous pouvez nous écrire à{" "}
        <a href="mailto:nordstellatech@gmail.com">nordstellatech@gmail.com</a> ou
        via notre <a href="/contact">formulaire de contact</a>.
      </p>
    </Legal>
  );
}
